export default "__VITE_PUBLIC_ASSET__4c88267d__"